var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckTik(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 18.3333C5.39746 18.3333 1.6665 14.6023 1.6665 9.99999C1.6665 5.39761 5.39746 1.66666 9.99984 1.66666C14.6022 1.66666 18.3332 5.39761 18.3332 9.99999C18.3332 14.6023 14.6022 18.3333 9.99984 18.3333ZM9.99984 16.6667C13.6818 16.6667 16.6665 13.6819 16.6665 9.99999C16.6665 6.31809 13.6818 3.33332 9.99984 3.33332C6.31794 3.33332 3.33317 6.31809 3.33317 9.99999C3.33317 13.6819 6.31794 16.6667 9.99984 16.6667ZM9.16867 13.3333L5.63316 9.79782L6.81168 8.61924L9.16867 10.9763L13.8828 6.26226L15.0613 7.44076L9.16867 13.3333Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckTik);
export default __webpack_public_path__ + "static/media/check-tik.4634bbb5af6f57c8bd584237d3452dd7.svg";
export { ForwardRef as ReactComponent };